import { Alert, Container, Stack, Title } from "@assetwatch/ui";
import type { ReactNode } from "react";
import { useFeatureFlags } from "./LaunchDarkly/useFeatureFlags";

export function AppFeatureGate({ children }: { children: ReactNode }) {
  const flags = useFeatureFlags();

  if (!flags.cmeEnabled) {
    return (
      <Container size="sm">
        <Stack gap={16}>
          <Title size="lg">CME is not enabled</Title>
          <Alert
            tone="informative"
            title="Enable the rollout flag or change the local default while building this app."
          />
        </Stack>
      </Container>
    );
  }

  return <>{children}</>;
}
